import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../actions'
import marked from 'marked'
import { doTrack } from '../../helpers/TaggingSerializer'

import Sidebar from '../../components/Sidebar/Sidebar'
import Meta from '../../components/Meta/Meta'
import LoadingError from '../../components/LoadingError/LoadingError'
import FAQAccordions from '../../components/FAQAccordions/FAQAccordions'
import LiveChat from '../../components/LiveChat/LiveChat'
import SearchBar from '../../components/SearchBar/SearchBar'

import './Page.scss'

class Page extends PureComponent {
  static waitForDataServer (dispatch, params, req, res) {
    return Promise
      .all([
        dispatch(actions.fetchSidebarNav(true)),
        dispatch(actions.fetchPageContent(params.pageId, true))
      ])
      .then(([sidebar, page]) => {
        if (page.payload.id === 0) {
          res.statusCode = 404
        }
      })
  }

  static waitForDataClient (store) {
    return (nextState, transition, callback) => {
      const { dispatch, getState } = store
      const state = getState()
      const page = state.page.page

      if (page && page.permalink === `/help/${nextState.params.pageId}/`) {
        return callback()
      }

      dispatch(actions.fetchPageContent(nextState.params.pageId))
        .then(() => { callback() })
        .catch(() => { callback() })
    }
  }

  componentDidMount () {
    this.fireAnalytics()
  }

  componentWillReceiveProps (newProps) {
    if (this.props.routeParams.pageId !== newProps.routeParams.pageId) {
      this.fireAnalytics()
    }
  }

  fireAnalytics = () => {
    if (window.digitalData) {
      const pagename = this.props.page.title.replace(/ /g, '').replace(/-/g, '').replace(/&/g, '').replace(/,/g, '')
      window.digitalData.page.pageInfo.pageName = 'ar:help:page:' + pagename.toLowerCase()
      window.digitalData.page.pageInfo.templateTitle = 'help_PAGE'
    }

    doTrack('help_initialLoad')
  }

  render () {
    const { error, sidebar, page, loading } = this.props
    const pageCcn = 'page'

    if (error) return <LoadingError />

    if (page.title === null) {
      page.meta.title = 'Page not found | Go Argos'
      return (
        <div className={'helpfaq faq ' + pageCcn + ' container'}>
          <div id='helpfaqcontent' tabIndex='-1' />
          <Meta pagemeta={page} />

          <div className='container'>
            <div className='xs-row xs-row--negative'>
              <div className='xs-12'>
                <h2 className='h2 page__title'>Page not found</h2>
                <p className='page__content'>
                  The requested page could not be found.
                </p>
                <p>
                  <a href='/help/' className='faq__button faq__button--back-to-help-home'>
                    <span className='argos-icon icon-UIE-Controls-Chevron-Left' aria-hidden='true' />
                    Back to help home
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className={'helpfaq ' + pageCcn}>
        <Meta pagemeta={page} />

        <div className='container'>
          <div id='helpfaqcontent' tabIndex='-1' />
          <div className='xs-row xs-row--negative'>
            <Sidebar activePage={page.permalink} links={sidebar} loading={loading} />

            <div className='xs-12 lg-9 content'>

              <h2 className='h2 page__title'>{page.title}</h2>

              <div className='page__content' dangerouslySetInnerHTML={{ __html: marked(page.content) }} />

              {
                page.related_faqs.length > 0 &&
                <FAQAccordions faqs={page.related_faqs} />
              }

              <LiveChat
                actions={this.props.actions}
                chatHasEnded={this.props.chatHasEnded}
                chatLoading={this.props.chatLoading}
                chatOnline={this.props.chatOnline}
              />

              <SearchBar position='bottom' />

            </div>
          </div>
        </div>

      </div>
    )
  }
}

Page.propTypes = {
  error: PropTypes.bool,
  sidebar: PropTypes.array,
  actions: PropTypes.object,
  page: PropTypes.object,
  loading: PropTypes.bool,
  routeParams: PropTypes.object,
  chatHasEnded: PropTypes.bool,
  chatLoading: PropTypes.bool,
  chatOnline: PropTypes.bool
}

function mapStateToProps (state) {
  return {
    sidebar: state.help.sidebar,
    page: state.page.page,
    error: state.page.pageError,
    loading: state.page.pageLoading,
    chatHasEnded: state.page.chatHasEnded,
    chatLoading: state.page.chatLoading,
    chatOnline: state.page.chatOnline
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Page)
